import React from 'react';
import {sizes, svgs} from 'epic-diesel-common/src/constants';
import {Icon, Message} from 'epic-diesel-common';
import {NavLink} from 'react-router-dom';
import {generateRoutePath} from 'epic-common/src/route';
import styles from './SignUpHeaderSection.pcss';

export default class SignUpHeaderSection extends React.Component {
    render() {
        return (
            <div className={styles.section}>
                <NavLink to={generateRoutePath('overview')}>
                    <Icon className={styles.back} icon={svgs.ARROW} size={sizes.XSMALL} />
                </NavLink>
                <Message code="epic.affiliate.signup.header" className={styles.title} />
            </div>
        );
    }
}
